import { HfsActionEnum } from 'fleet-data-model';
import {
  parkActionTypes,
  pauseActionTypes,
  playActionTypes,
} from '~/domain/roboticmower-details/components/ControlButtons/utils';

export const controlButtonsActionsTypes = [
  ...parkActionTypes,
  ...pauseActionTypes,
  ...playActionTypes,
];
export const rebootActionTypes = [HfsActionEnum.HAPP_REBOOT];
export const checkFotaActionTypes = [HfsActionEnum.MOWER_CHECK_FOTA];
